import React, { useEffect, useState } from "react";
import { db, collection, onSnapshot } from "../boardData";
import { WidgetShell, EmptyState } from "./common";

// Agency memo feed: the top-level collection named exactly after the agency.
const MemosWidget = ({ config = {}, agency }) => {
  const [memos, setMemos] = useState([]);
  const limit = config.limit || 5;
  const allowed = config.privacy || ["All", "stationboard"];

  useEffect(() => {
    if (!agency) return undefined;
    const unsub = onSnapshot(
      collection(db, agency),
      (snap) => {
        const list = snap.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .filter((m) => m.postTime || m.message || m.text || m.title)
          .filter((m) => !m.privacy || allowed.includes(m.privacy))
          .sort((a, b) => (b.postTime?.seconds || 0) - (a.postTime?.seconds || 0))
          .slice(0, limit);
        setMemos(list);
      },
      (err) => console.warn("memos load failed", err)
    );
    return () => unsub();
  }, [agency, limit]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <WidgetShell title="Memos & Announcements">
      {memos.length === 0 ? (
        <EmptyState icon="✎" label="No current memos." />
      ) : (
        <div className="sb-memo-list">
          {memos.map((m) => (
            <div className="sb-memo" key={m.id}>
              {m.title && <div className="sb-memo-title">{m.title}</div>}
              <div className="sb-memo-body">{m.message || m.text || m.body}</div>
              {m.postTime?.seconds && (
                <div className="sb-memo-date">
                  {new Date(m.postTime.seconds * 1000).toLocaleDateString()}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </WidgetShell>
  );
};

export default MemosWidget;
